"use strict";
function onEntry(entry) {
    entry.forEach(function(change) {
        if (change.isIntersecting) change.target.classList.add("element-show");
    });
}
var options = {
    threshold: [
        0.3
    ]
};
var observer = new IntersectionObserver(onEntry, options);
var elements = document.querySelectorAll(".element-animation");
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var elm = _step.value;
        observer.observe(elm);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

//# sourceMappingURL=index.45afc17a.js.map
